module.exports = __webpack_public_path__ + "img/g2.717099d2.jpg";